"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _CoreCharge = _interopRequireDefault(require("./CoreCharge"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TotalPrice = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TotalPrice, _Component);

  var _super = _createSuper(TotalPrice);

  function TotalPrice() {
    (0, _classCallCheck2["default"])(this, TotalPrice);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(TotalPrice, [{
    key: "getTotalPrice",
    value: function getTotalPrice(price, qty) {
      return (parseFloat(price.replace(/,/g, '')) * parseFloat(qty)).toFixed(2);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          price = _this$props.price,
          qty = _this$props.qty,
          special = _this$props.special,
          coupon = _this$props.coupon,
          coreCharge = _this$props.coreCharge;
      var totalPrice = this.getTotalPrice(price, qty);
      var core = coreCharge ? this.getTotalPrice(coreCharge, qty) : 0;

      if (typeof special !== 'undefined') {
        var specialPrice = this.getTotalPrice(special.price, special.qty);
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textDecoration: 'line-through'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body1"
        }, /*#__PURE__*/_react["default"].createElement("b", null, "$", totalPrice))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: 'red'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body1"
        }, /*#__PURE__*/_react["default"].createElement("b", null, "$", specialPrice))), /*#__PURE__*/_react["default"].createElement(_CoreCharge["default"], {
          charge: core
        }));
      } else if (typeof coupon !== 'undefined') {
        var couponPrice = this.getTotalPrice(coupon.price, coupon.qty);
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textDecoration: 'line-through'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body1"
        }, "$", totalPrice)), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: 'green'
          }
        }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
          variant: "body1"
        }, "$", couponPrice)), /*#__PURE__*/_react["default"].createElement(_CoreCharge["default"], {
          charge: core
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, /*#__PURE__*/_react["default"].createElement("b", null, "$", totalPrice))), /*#__PURE__*/_react["default"].createElement(_CoreCharge["default"], {
        charge: core
      }));
    }
  }]);
  return TotalPrice;
}(_react.Component);

exports["default"] = TotalPrice;